<style lang="scss">
@import "@styles/_mixins.scss";
@import "./document-viewer.scss";
</style>

<template>
  <transition name="slide-fade">
    <div row wrap class="document-viewer" v-if="isVisible" v-on:click.self="onBackdropClicked">
      <iframe class="pdfjs-viewer-iframe" v-if="isPdf" :src="getSourceURL" frameborder="0"></iframe>
      <!-- <div id="pdfHolder" class="viewer-frame" v-if="isPdf" v-bind:item="loadPdf()" xs12></div> -->
      <img class="image-frame" :src="sourceUrl" v-if="isImage" />
      <iframe class="word-viewer" :src="sourceUrl" v-if="isDoc"></iframe>
      <!-- <div class="btn-download" v-on:click="onDownloadFile">
        <v-icon>download</v-icon>
      </div> -->
      <div class="btn-close" v-on:click="onBackdropClicked">
        <v-icon>close</v-icon>
      </div>
    </div>
  </transition>
</template>

<script>
import PDFJS from "pdfjs-dist";

let loadPdfFile = async (component) => {
  let loadPdf = await PDFJS.getDocument(component.sourceUrl);
  //render the first page
  await renderPages(loadPdf, 1, component);
};

let renderPages = async (data, currentPage, component) => {
  let pageData = await data.getPage(currentPage);
  let pdfHolder = document.getElementById("pdfHolder");
  let scale = component.scale;
  let viewport = pageData.getViewport(scale);

  //Scale the viewport depending on the width
  // let scale = pdfHolder.clientWidth / viewport.width;

  // viewport = pageData.getViewport(scale);

  //paint the canvas
  let canvas = document.createElement("canvas");
  let context = canvas.getContext("2d");
  pdfHolder.appendChild(canvas);

  canvas.height = viewport.height;
  canvas.width = viewport.width;

  pageData.render({ canvasContext: context, viewport: viewport });
  //increment then invoke this same function
  currentPage++;
  if (currentPage <= data.numPages) {
    renderPages(data, currentPage, component);
  }
};
export default {
  name: "DocumentViewer",
  props: {
    isVisible: Boolean,
    sourceUrl: String,
    fileName: String,
    useDirectUrl: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isViewerRendered() {
      return this.isVisible && this.sourceUrl;
    },
    isPdf() {
      return this.fileName && this.fileName.endsWith(".pdf");
    },
    isImage() {
      let { fileName } = this;

      return fileName && (fileName.endsWith(".jpg") || fileName.endsWith(".jpeg") || fileName.endsWith(".png"));
    },
    isDoc() {
      let { fileName } = this;

      return fileName && (fileName.endsWith(".doc") || fileName.endsWith(".docx"));
    },
    getSourceURL() {
      if (this.useDirectUrl) return `${this.sourceUrl}#navpanes=0&pagemode=none&view=FitBH`;
      return `/viewer/web/viewer.html?file=${this.sourceUrl}`;
    },
  },
  methods: {
    onBackdropClicked() {
      this.page = 1;
      this.$emit("on-document-closed");
    },
    async onDownloadFile() {
      console.log("download", this.sourceUrl);
    },
    async loadPdf() {
      await loadPdfFile(this);
    },
  },
  data() {
    return {
      page: 1,
      scale: 1,
    };
  },
};
</script>
